import { BASE_URL, BASE_NODE_URL } from "./Config";

// Kill-switch: false sends every endpoint below back to PHP without touching a call site.
export const USE_NODE_CI = true;

// Node serves the PHP api-ci routes under <BASE_NODE_URL>ci/ with the same path, payload and response.
export const BASE_CI_NODE_URL = BASE_NODE_URL ? `${String(BASE_NODE_URL).replace(/\/+$/, "")}/ci/` : "";

// Lowercase controller/method; matched case-insensitively. Remove one to send it back to PHP.
// Each was compared byte for byte with prod PHP from panel sessions (2026-10-25, 2026-10-26, 2026-10-27);
// sign-in (create_session login + store switch, login_via_superadmin) end to end 2026-10-29;
// login_with_code (POS Dashboard button -> panel) end to end 2026-10-30.
// Product writes (edit, channels, brands/tags, lookups, vendors, instant PO, variant sort/order, online ordering,
// mass update) and the BOGO variant list: UI on the test store, PHP vs Node rows + audit compared 2026-11-04.
// Switched on request 2026-11-04 without an end-to-end comparison: add_product (needs Node PR #265 live first),
// new_saleshistory, saleshistory_count, save_vendor_list, delete_multiple_products.
// Productapi products_list_dropdown (product pickers: replay 25/25 + Related Products UI) and update_product_variant
// (Variants page Save, variant + single product: rows + audit identical): PHP vs Node compared live 2026-11-05.
// Timesheet, taxes, customers, product lookups/custom codes, gift card reads: live PHP vs Node end to end 2026-11-03
// (owner session replays + UI writes on the test store: add/update/delete tax, add/edit/delete time card).
// interceptors/authInterceptor.js sends these URLs the same Bearer token and session fields as PHP.
export const NODE_CI_PATHS = new Set([
  "api/settingsreact_api/system_access",
  "app/employee_list",
  "app/find_customer",
  "app/get_qty_byid",
  "app/save_customer_details",
  "app/vendor_payment_list",
  "bogoapi/bogo_list",
  "categoryapi/category_list",
  "categoryreactapi/mass_update_category_tax",
  "customer_merchant_api/pending_customer_list",
  "customer_merchant_api/update_customer_approval_status",
  "configure_category_api/config_cat_list",
  "dashboard/login_via_superadmin",
  "exportinventory_api/export_restriction_status",
  "feature_announcements_api/show_feature_announcements",
  "inventoryreportpk/category_list",
  "loginapireact/chk_merchant",
  "loginapireact/create_session",
  "loginapireact/login_with_code",
  "loyalty_program_api/loyality_point_transaction",
  "orders/change_order_status",
  "orders/order_details",
  "orders/order_list",
  "product_api_react/assign_product_vendors_list",
  "product_api_react/check_producttitle",
  "product_api_react/check_upc",
  "product_api_react/check_upc_form",
  "product_api_react/delete_product",
  "product_api_react/get_productdata_byid",
  "product_api_react/list_brand_tag",
  "product_api_react/product_vendors_list",
  "product_api_react/products_list",
  "productapi/get_variantdata_byid",
  "profile_setup/inventory_register_setting",
  "react_max_purchase_api/mix_match_pricing_list",
  "settingapi/store_details",
  "settingapi/tax_list",
  "store_setting_react_api/employee_list",
  "store_setting_react_api/employee_list_v2",
  "store_setting_react_api/getemployeebyempid",
  "store_setting_react_api/getmanagerstores",
  "usercontroller/add",
  "usercontroller/check_admin_employee_email",
  "usercontroller/check_login_store_name",
  "usercontroller/check_merchant",
  "usercontroller/get_all_merchant_admin_pk",
  "usercontroller/get_permissions",
  "usercontroller/getadmins",
  "usercontroller/getunverifiedmerchant",
  "usercontroller/getunverifiedmerchantcount",
  "usercontroller/insert_admin_pk",
  "usercontroller/update_admin_pk",
  "usercontroller/update_single_store",
  "varient_react_api/varients_list",
  "store_setting_react_api/permission_list",
  "timesheet_api/daily_review_list",
  "timesheet_api/get_attendance_by_id",
  "timesheet_api/add_edit_time_card",
  "timesheet_api/timesheet_list",
  "timesheet_api/pay_period_summary",
  "timesheet_api/delete_emp_breaks",
  "timesheet_api/summary_details",
  "customerapi/latest_customer_list",
  "customerapi/new_customer_list_count",
  "product_api_react/get_productdata_byid_v2",
  "product_api_react/lookup_list",
  "product_api_react/check_custom_code",
  "taxes_react_api/taxes_list",
  "taxes_react_api/taxes_category_list",
  "taxes_react_api/edit_taxes",
  "taxes_react_api/update_tax",
  "taxes_react_api/add_tax",
  "taxes_react_api/delete_tax",
  "gift_ebt_api/get_giftcard",
  "gift_ebt_api/gift_card_history",
  "store_setting_react_api/deleted_employee_list",
  "onlinestorereactnewui/banners_list",
  "onlinestorereactnewui/bannerdatabyid",
  "gift_ebt_api/adjust_giftcard",
  "shift_inout/drop_cash",
  "shift_inout/payin_cash",
  "product_api_react/edit_produt",
  "product_api_react/product_show_status_update",
  "product_api_react/add_brand_tag",
  "product_api_react/update_brand_tag",
  "product_api_react/delete_brand_tag",
  "product_api_react/lookup_add",
  "product_api_react/assign_product_vendors",
  "product_api_react/assign_preferred_vendor",
  "product_api_react/delete_product_vendor",
  "product_api_react/bulk_assign_vendors",
  "product_api_react/save_instant_po",
  "product_api_react/bulk_instant_po",
  "product_api_react/sort_variants",
  "product_api_react/generate_variant_alternat_names",
  "product_api_react/update_type",
  "product_api_react/mass_update_inventory",
  "product_api_react/variant_list_pagination",
  "product_api_react/add_product",
  "product_api_react/new_saleshistory",
  "product_api_react/saleshistory_count",
  "product_api_react/save_vendor_list",
  "product_api_react/delete_multiple_products",
  "productapi/products_list_dropdown",
  "productapi/update_product_variant",
]);

const routeKey = (path) =>
  String(path ?? "").split("?")[0].replace(/^\/+|\/+$/g, "").toLowerCase();

export const ciBase = (path, phpBase = BASE_URL) =>
  USE_NODE_CI && BASE_CI_NODE_URL && NODE_CI_PATHS.has(routeKey(path)) ? BASE_CI_NODE_URL : phpBase;

export const ciUrl = (path, phpBase = BASE_URL) => ciBase(path, phpBase) + path;
